/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AlarmStatsResponse
 */
export interface AlarmStatsResponse {
  /**
   *
   * @type {number}
   * @memberof AlarmStatsResponse
   */
  totalActive: number;
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof AlarmStatsResponse
   */
  byRulePrefix: { [key: string]: number };
}

/**
 * Check if a given object implements the AlarmStatsResponse interface.
 */
export function instanceOfAlarmStatsResponse(
  value: object,
): value is AlarmStatsResponse {
  if (!("totalActive" in value) || value["totalActive"] === undefined)
    return false;
  if (!("byRulePrefix" in value) || value["byRulePrefix"] === undefined)
    return false;
  return true;
}

export function AlarmStatsResponseFromJSON(json: any): AlarmStatsResponse {
  return AlarmStatsResponseFromJSONTyped(json, false);
}

export function AlarmStatsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AlarmStatsResponse {
  if (json == null) {
    return json;
  }
  return {
    totalActive: json["totalActive"],
    byRulePrefix: json["byRulePrefix"],
  };
}

export function AlarmStatsResponseToJSON(json: any): AlarmStatsResponse {
  return AlarmStatsResponseToJSONTyped(json, false);
}

export function AlarmStatsResponseToJSONTyped(
  value?: AlarmStatsResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    totalActive: value["totalActive"],
    byRulePrefix: value["byRulePrefix"],
  };
}
